<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :footer="footer"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
// import {
//   getRules,
//   getRulesDetails,
//   createRules,
//   updateRules,
//   delRules
// } from "@/api/stockManage/stockManage.js";
// import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable
  },
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      config: {
        height: 500,
        slot: "div",
        resize: false
      },
      methods: {
        list: getRules
        // getuser,
        // getgoodsInfo,
        // getBulkStockInfo,
        // setupBulkStock
      },
      footer: {
        show: () => false
      },
      modals: {
        add: {
          contentSlot: "ADDCONTENT",
          methods: {
            // ok({ row, close }) {
            //   let data = row;
            //   data.sku = this.list;
            //   this.$page
            //     .handleRequestMethods("setupBulkStock", data)
            //     .then(e => {
            //       console.log(e);
            //       close();
            //     });
            // }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 700
            },
            formBind: {
              labelWidth: 100,
              disabled() {
                return this.disabled;
              }
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ client_id: 24 }, { sku_code: 24 }, { remark: 24 }],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "Select",
              bind: {
                placeholder: "Please Select Client",
                filterable: true
              },
              disabled() {
                return !!this.$page.getModal("add").list.length;
              },
              config: {
                value: "id",
                label: "account"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getuser")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: this.$t("barCode"),
              component: "Input",
              bind: {
                placeholder: "Please Enter Code"
              },
              key: "sku_code",
              methods: {
                async "on-enter"() {
                  let data = (
                    await this.$page.handleRequestMethods(
                      "getgoodsInfo",
                      this.formData
                    )
                  ).payload;
                  let res = this.$modal.list.find(item => {
                    if (item.id === data.id) {
                      item.sku_count += 1;
                      return true;
                    }
                  });
                  if (!res) {
                    data.sku_count = 1;
                    data.sku_id = data.id;
                    this.$modal.list.push(data);
                  }
                }
              }
            },
            {
              name: this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2, maxRows: 6 }
              },
              key: "remark"
            }
          ],
          table: {
            config: {
              align: "center",
              height: 400
            },
            fields: [
              {
                name: this.$t("skuCode"),
                key: "bar_code",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: this.$t("price"),
                key: "declaration_amount",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: this.$t("number"),
                key: "sku_count",
                align: "center",
                component(params) {
                  let modal = this.$page.getModal("add");
                  return modal.$refs["form"] && modal.$refs["form"].disabled
                    ? "TableExpand"
                    : "InputNumber";
                },
                tooltip: true,
                minWidth: 100,
                render(h, p) {
                  return h("span", p.row.sku_count);
                }
              },
              {
                name: this.$t("total"),
                align: "center",
                tooltip: true,
                minWidth: 100,
                methods: {
                  render({ row }) {
                    return this.toFixed(row.declaration_amount * row.sku_count);
                  }
                }
              },
              {
                name: this.$t("operation"),
                align: "center",
                minWidth: 100,
                type: "btns",
                show() {
                  let modal = this.$page.getModal("add");
                  console.log("modal", modal);
                  return modal.disabled ? false : true;
                },
                list: [
                  {
                    name: this.$t("delete"),
                    type: "preview",
                    fnName: "delete"
                  }
                ],
                methods: {
                  delete({ rowIndex }) {
                    let modal = this.getModal("add");
                    modal.list = modal.list.filter((t, i) => i !== rowIndex);
                  }
                }
              }
            ]
          }
        }
      },
      header: {
        render(h, p) {
          return h(
            "span",
            {
              style: {
                "line-height": "100px"
              }
            },
            "cs"
          );
        },
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "success"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              console.log("add");
              this.getModal("cs").open();
              return;
              console.log(this.getModal("add"));
              this.getModal("add").disabled = false;
              this.getModal("add").open();
              this.getModal("add").setTitle(this.$t("add"));
            }
          }
        }
      },
      fields: [
        {
          type: "btns",
          width: 200,
          name: () => this.$t("operation"),
          fixed: "right",
          width({ field }) {
            return field.list.length * 40 + 40;
          },
          list: [
            {
              name: () => this.$t("show"),
              type: "preview",
              fnName: "show",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            // show({ row, rowIndex }) {
            //   this.handleRequestMethods("getBulkStockInfo", row.id).then(
            //     res => {
            //       this.getModal("add").list = res.payload.sku;
            //       this.getModal("add").disabled = true;
            //       this.getModal("add").setTitle(this.$t("show"));
            //       this.getModal("add").open(res.payload, function() {
            //         this.$refs["form"].disabled = true;
            //       });
            //     }
            //   );
            // }
          }
        },
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          component: "Button",
          tooltip: true,
          minWidth: 100
        },
        {
          name: () => this.$t("collection") + this.$t("mode"),
          key: "billing_method",
          align: "center",
          tooltip: true,
          minWidth: 125
        },
        {
          name: () => this.$t("ratio"),
          key: "fix_fee_rate",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("fixed") + this.$t("reChAmount"),
          key: "fee_amount",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("currency_t"),
          key: "fee_amount_currency",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("currency_t"),
          key: "fee_amount_currency",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () =>
            this.$t("interval") + this.$t("lowest") + this.$t("reChAmount"),
          key: "scope_min_cod",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () =>
            this.$t("interval") + this.$t("highest") + this.$t("reChAmount"),
          key: "scope_max_cod",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
          tooltip: true,
          minWidth: 185
          // methods: {
          //   render({ value }) {
          //     return ~~value ? this.format.timeFormat(value * 1000) : "-";
          //   }
          // }
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          tooltip: true,
          minWidth: 100
        }
      ]
    };
  },
  mounted() {
    console.log(this.params);
  }
};
</script>
